import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';
import { Sublocation } from './sublocation';

@inheritSerialization(AbstractModel)
export class Location extends AbstractModel {
  @autoserialize
  display: string;

  @autoserialize
  streetAddress1: string;

  @autoserialize
  streetAddress2: string;

  @autoserialize
  streetAddress3: string;

  @autoserialize
  city: string;

  @autoserialize
  stateCode: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserializeAs(Sublocation)
  sublocations: Array<Sublocation>;
}
